export const ONE_SECOND = 1_000;
export const ONE_MINUTE = 60 * ONE_SECOND;
export const ONE_HOUR = 60 * ONE_MINUTE;
export const ONE_DAY = 24 * ONE_HOUR;
// These are approximations and for more precise calculations
// use 'luxon' which is available in the monorepo.
export const ONE_MONTH = 30 * ONE_DAY;
export const ONE_YEAR = 365 * ONE_DAY;
export const SECONDS_IN_10_DAYS = (10 * ONE_DAY) / ONE_SECOND;
